export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const CHANGE_NEW_PASSWORD_FIELD = 'CHANGE_NEW_PASSWORD_FIELD';

export const RESET_ALL_FIELDS = 'RESET_ALL_FIELDS';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';

export const SHIFT_PASSWORD_COMPONENT = 'SHIFT_PASSWORD_COMPONENT';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';

export const GET_SAVED_SEARCHES_LIST = 'GET_SAVED_SEARCHES_LIST';
export const DELETE_SAVED_SEARCH = 'DELETE_SAVED_SEARCH';
export const CHANGE_SAVED_SEARCH = 'CHANGE_SAVED_SEARCH';

export const CHANGE_FIELD_JOB_FORM = 'action/CHANGE_FIELD_JOB_FORM';
export const CHANGE_VALUE_FIELD = 'CHANGE_VALUE_FIELD';

export const CHANGE_COMPANIES_OF_INTEREST_REQUEST = 'mutation/CHANGE_COMPANIES_OF_INTEREST_REQUEST';
export const CHANGE_COMPANIES_OF_INTEREST_SUCCESS = 'mutation/CHANGE_COMPANIES_OF_INTEREST_SUCCESS';

export const FETCH_COMPANIES_OF_INTEREST = 'action/FETCH_COMPANIES_OF_INTEREST';
